<template>
  <div>
    <form
      v-if="checkPermission('contacts_files', PERMISSIONS.CAN_CREATE)"
      method="post"
    >
      <v-toolbar
        style="padding-top:15px;"
        color="white"
        flat
        dense
      >
        <div style="display:inline-block;width:100%;height:32px;color:lightgrey;font-size:18px;">
          <input
            type="file"
            ref="files"
            multiple
            v-on:change="handleFileUploads()"
          />
        </div>
        <v-btn
          :disabled="!files"
          color="blue"
          flat
          @click="submitFiles()"
        >
          <v-icon left>cloud</v-icon> Upload File
        </v-btn>
      </v-toolbar>
    </form>
    <v-data-table
      :items="contact.uploads"
      :headers="fileHeaders"
      disable-initial-sort
    >
      <template slot="no-data">
        <tr>
          <td colspan="3">
            <div style="text-align:center;padding:25px;">
              <v-icon size="125px">find_in_page</v-icon>
              <h3>No Files Uploaded</h3>
            </div>
          </td>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <a
              style="text-decoration: underline"
              @click="getFile(props.item)"
            >
              <b>{{ props.item.name }}</b>
            </a>
          </td>
          <td>
            {{ convertToLocal(props.item.created_at) }}<br />
            <small style="color:black;">{{props.item.created_by_name}}</small>
          </td>
          <td>
            {{ convertToLocal(props.item.updated_at) }}<br />
            <small style="color:black;">{{props.item.updated_by_name}}</small>
          </td>
          <td>
            <v-icon
              v-if="checkPermission('contacts_files', PERMISSIONS.CAN_DELETE)"
              style="padding-right:10px;"
              @click="deleteFile(props.item)"
            >
              delete
            </v-icon>
            <v-tooltip
              v-if="checkPermission('contacts_files_read', PERMISSIONS.CAN_EDIT)"
              left
            >
              <v-icon
                :color="props.item.read ? '#cfcfcf' : '#1976d2'"
                v-on="on"
                @click="updateReadStatus(props.item)"
                slot="activator"
              >
                {{ props.item.read ? 'visibility_off' : 'visibility' }}
              </v-icon>
              <span>{{ props.item.read ? 'Mark Unread' : 'Mark Read' }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="deleteDialog"
      width="400"
    >
      <v-card
        style="color: white; background: #F44336;text-align:center;"
      >
        <v-card-text>
          <v-icon
            size="72"
            color="white"
          >
            mdi-delete-alert
          </v-icon>
          <h2>Are you sure?</h2>
          <p>You are about to delete `{{fileAction.name}}`.<br /><b>This action is irreversable.</b></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="white"
            @click="deleteFile()"
          >
            I Understand, Delete
          </v-btn>
          <v-btn
            color="blue"
            dark
            @click="deleteDialog = false"
          >
            Go Back
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'ContactFiles',
  props: [ 'contact', 'loading' ],
  data () {
    return {
      searching: false,
      files: '',
      deleteDialog: false,
      fileAction: {},
      fileHeaders: [
        { text: 'File Name', value: 'name', sortable: false },
        { text: 'Created', value: 'created_at', sortable: false },
        { text: 'Updated', value: 'updated_at', sortable: false },
        { text: 'Actions', sortable: false, width: 175}
      ]
    }
  },
  methods: {
    getFile (file) {
      this.$emit('update:loading', true)
      api.userform.contact.downloadFile(this.contact, file.id)
      .then(response => {
        this.$emit('update:loading', false)
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.name
        link.click()
      })
    },
    handleFileUploads () {
      this.files = this.$refs.files.files
    },
    submitFiles () {
      this.$emit('update:loading', true)
      let formData = new FormData()
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i]
        formData.append(`upload`, file)
      }
      api.userform.contact.uploadFile(this.contact, formData)
        .then(response => {
          this.$emit('update:loading', false)
          this.$emit('update:contact', response.data)
          this.files = ""
        })
        .catch(err => {
          this.$emit('update:loading', false)
        })
    },
    deleteFile (item = null) {
      if (item) {
        this.fileAction = item
        this.deleteDialog = true
      } else {
        if (this.fileAction) {
          this.$emit('update:loading', true)
          api.userform.contact.deleteFile(this.contact, this.fileAction.id)
          .then(() => {
            this.$emit('reload')
            this.files = []
          })
          .finally(() => {
            this.$emit('update:loading', false)
            this.deleteDialog = false
          })
        }
      }
    },
    updateReadStatus (object) {
      object.read = !object.read
      api.userform.contactFilesPage.save({id: object.id, read: object.read})
    }
  }
}
</script>
